import {initScriptForm} from "../../agents/voe-orders/scripts/initScriptForm";
import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {getFilesDataFromMediaCollection} from "../../helpers/media-library/collections";
import {initProcessingLog} from "../../common/voe-orders/initProcessingLog";

function initThirdPartyOrdersProcess() {
	const voeResultFields = [

		// Standard script fields
		'voe_result_origin_key',
		'employer_division',
		'employment_status_key',
		'job_title',
		'most_recent_start_date',
		'most_recent_end_date',
		'original_start_date',
		'years_with_employer',
		'months_with_employer',
		'reason_for_leaving',
		'compensation',
		'other_information',
	];

	const scriptContainer = document.querySelector('.scripts-wrapper');

	initScriptForm(scriptContainer);

	// Setup script buttons
	const saveProgressButton = document.querySelector('.update-script-button');
	if (saveProgressButton) {
		saveProgressButton.addEventListener('click', () => handleSaveProgressRequest());
	}

	const submitVerificationButton = document.querySelector('.submit-script-button');
	if (submitVerificationButton) {
		submitVerificationButton.addEventListener('click', () => handleSubmitVerificationRequest());
	}

	const rejectVerificationButton = document.querySelector('.reject-script-button');
	if (rejectVerificationButton) {
		rejectVerificationButton.addEventListener('click', () => handleRejectVerificationRequest());
	}

	const sentToCallQueueButton = document.querySelector('.send-to-call-queue-button');
	if (sentToCallQueueButton) {
		sentToCallQueueButton.addEventListener('click', () => handleSendToCallQueueRequest());
	}

	// Init log container
	initProcessingLog(scriptContainer);

	/**
	 * Methods
	 */

	function handleSaveProgressRequest() {
		const voeResultData = getInputsByName(scriptContainer, voeResultFields);

		// Append file data to request
		voeResultData.files = getFilesDataFromMediaCollection(scriptContainer, 'files')

		clearFeedbacksByName(scriptContainer, voeResultFields)

		loading();


		Axios.post(window['routes/third-party.save-progress'], voeResultData)
			.then(response => {
				handleAjaxSuccess(response, () => {
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handleSubmitVerificationRequest() {
		const voeResultData = getInputsByName(scriptContainer, voeResultFields);

		// Append file data to request
		voeResultData.files = getFilesDataFromMediaCollection(scriptContainer, 'files')

		clearFeedbacksByName(scriptContainer, voeResultFields)

		loading();

		Axios.post(window['routes/third-party.submit-verification'], voeResultData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handleRejectVerificationRequest() {
		const voeResultData = getInputsByName(scriptContainer, voeResultFields);

		// Append file data to request
		voeResultData.files = getFilesDataFromMediaCollection(scriptContainer, 'files')

		clearFeedbacksByName(scriptContainer, voeResultFields)

		loading();

		Axios.post(window['routes/third-party.reject-verification'], voeResultData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function handleSendToCallQueueRequest() {
		loading();

		Axios.post(window['routes/third-party.send-to-call-queue'])
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {
	initThirdPartyOrdersProcess
};
